// src/utils/imageCache.js
class ImageCacheManager {
  constructor() {
    this.cache = new Map();
    this.preloadQueue = [];
    this.isPreloading = false;
  }

  preloadImages(imageUrls) {
    const newImages = imageUrls.filter(url => url && !this.cache.has(url));
    
    newImages.forEach(url => {
      const img = new Image();
      
      img.onload = () => {
        this.cache.set(url, { loaded: true, error: false });
      };
      
      img.onerror = () => {
        this.cache.set(url, { loaded: false, error: true });
      };
      
      img.src = url;
    });
  }

  isImageCached(url) {
    return this.cache.has(url) && this.cache.get(url).loaded;
  }

  clearCache() {
    this.cache.clear();
  }
}

export const imageCache = new ImageCacheManager();